module.exports = __webpack_public_path__ + "img/a8589fc4c09a2a9c18a0024f6140daad.png";